<template>
    <div>
        <div class="grid grid-cols-2">
            <div class="font-bold text-xl">
                NỔI BẬT
            </div>
            <div class="text-right">
                <span @click="active -=1 " class="bg-main p-1 rounded-xl">
                    <b-icon style="color: white;" scale="1.5" icon="caret-left-fill" aria-hidden="true"></b-icon>
                </span>
                <span @click="active +=1 " class="bg-main p-1 ml-2 rounded-xl">
                    <b-icon style="color: white;" scale="1.5" icon="caret-right-fill" aria-hidden="true"></b-icon>
                </span>
            </div>
        </div>
        <div>
            <vue-glide v-if="data.length > 0" class="mt-3" :perView="1" :peek="{ before: 0, after: 0 }" v-model="active">
                <vue-glide-slide
                v-for="i in data"
                :key="i.id">
                    <div>
                        <div @click="viewDetail(i.id,i.slug)">
                            <img style="height: 176px !important;" height="176" width="100%" class="shadow-main" :src="i.image" fluid alt="vclick hot blog image">
                        </div>
                        <div @click="viewDetail(i.id,i.slug)" class="font-bold mt-3">
                            {{ i.name }}
                        </div>
                        <div class=" grid grid-cols-2 mt-2">
                            <div class="color-main2 font-bold ">
                                <span class="text-border"> {{ i.category_name }} </span>
                            </div>
                            <div class="text-right font-bold text-sm">
                                {{ i.created_time | toHMDMY }}
                            </div>
                        </div>
                    </div>
                </vue-glide-slide>
            </vue-glide>
        </div>

        
    </div>
</template>

<script>
import { Glide, GlideSlide } from 'vue-glide-js'
import { getHotBlog } from '@/api/otp'
import subRoute from '@/router/subRoute'

export default {
    // props: ['data'],
    components: {
        [Glide.name]: Glide,
        [GlideSlide.name]: GlideSlide
    },
    data(){
        return{
            active: 0,
            data: [
            ]
        }
    },
    methods: {
        viewDetail(id,slug){
            let r = subRoute + 'blog/chi-tiet/' +id +'/'+slug
            console.log(r)
            this.$router.push(r)
            //this.$router.push('/blog/chi-tiet/' +id +'/'+slug)
        },
        fetchHotBlog(){
            getHotBlog({}).then(res => {
                this.data = res.data
                console.log(this.data)
            })
        },

    },
    created(){
        this.fetchHotBlog()
    }
}
</script>

<style>

</style>